export type UserDisplayNameSource = {
  nombres?: string | null;
  apellidos?: string | null;
  nombreCompleto?: string | null;
  email?: string | null;
} | null | undefined;

export function splitFullName(fullName: string): { nombres: string; apellidos: string } {
  const trimmed = (fullName || '').replace(/\s+/g, ' ').trim();
  if (!trimmed) return { nombres: '', apellidos: '' };
  const parts = trimmed.split(' ');
  if (parts.length === 1) return { nombres: parts[0], apellidos: '' };
  return { nombres: parts[0], apellidos: parts.slice(1).join(' ') };
}

export function resolvePersonName(user?: UserDisplayNameSource): string {
  const nombres = String(user?.nombres ?? '').trim();
  const apellidos = String(user?.apellidos ?? '').trim();
  const composed = `${nombres} ${apellidos}`.replace(/\s+/g, ' ').trim();
  const completo = String(user?.nombreCompleto ?? '').trim();
  return composed || completo;
}

export function resolveLoggedInDisplayName(opts: {
  user?: UserDisplayNameSource;
  authDisplayName?: string | null;
  email?: string | null;
}): string {
  const auth = String(opts.authDisplayName ?? '').trim();
  const email = String(opts.email ?? opts.user?.email ?? '').trim();
  return resolvePersonName(opts.user) || auth || email;
}
